import React from 'react'
import './Toolbar.scss'

const ToolbarPlaceholder: React.FC<{}> = () => (
  <div className="toolbar" data-testid="toolbar"></div>
)

export default ToolbarPlaceholder
